export default "__VITE_ASSET__c3b31355__"